import React, { Component } from 'react';
import * as _ from 'lodash';
import * as PropTypes from 'prop-types';
import Select from 'react-select';
import TransparentButton from '../../../shared/button/transparent-button/TransparentButton';
import { BlueContainedButton } from '../../../shared/button/blue-contained-button/BlueContainedButton';
import { isSandboxBrand } from '../../../shared/models/jurisdictions';
import './client-access.scss';

/* A brand as an option of the select: "Casino Royale (MT)". */
export const makeBrandOption = brand => ({
    value: brand.id,
    label: `${brand.name} (${brand.jurisdiction})`
});

/* The brands that a credential can be bound to: those of production jurisdictions, as the backend refuses the others. */
export const bindableBrands = brands =>
    _.sortBy(
        _.reject(brands, isSandboxBrand),
        brand => `${brand.jurisdiction} ${_.toLower(brand.name)}`
    );

/*
  Changes the brands that an API user credential may send events for. What is chosen replaces what it had: a credential with no brand
  sends nothing, and the change takes effect on the next event it sends.
*/
export class EditClientBrandsModalContent extends Component {
    static propTypes = {
        credential: PropTypes.object,
        brands: PropTypes.array,
        onSave: PropTypes.func,
        onCancel: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            selected: _.map(
                _.get(props.credential, 'brands', []),
                makeBrandOption
            )
        };
    }

    componentDidUpdate(prevProps) {
        // Another credential is edited in the same modal
        if (
            _.get(prevProps.credential, 'id') !==
            _.get(this.props.credential, 'id')
        ) {
            this.setState({
                selected: _.map(
                    _.get(this.props.credential, 'brands', []),
                    makeBrandOption
                )
            });
        }
    }

    save = () =>
        this.props.onSave({
            id: this.props.credential.id,
            brandIds: _.map(this.state.selected, 'value')
        });

    render() {
        const { credential, brands, onCancel } = this.props;
        const selected = this.state.selected || [];

        return (
            <div className={'edit-client-brands'}>
                <div className={'client-access-note'}>
                    <strong>{_.get(credential, 'email')}</strong> can send
                    events and registrations only for the brands chosen here.
                    Whatever is chosen replaces what it has now.
                </div>
                <Select
                    isMulti
                    closeMenuOnSelect={false}
                    placeholder={'Choose the brands...'}
                    value={selected}
                    options={_.map(bindableBrands(brands), makeBrandOption)}
                    onChange={options =>
                        this.setState({ selected: options || [] })
                    }
                />
                {_.isEmpty(selected) && (
                    <div className={'client-access-warning'}>
                        With no brand, this API user credential sends nothing:
                        every event it sends is refused.
                    </div>
                )}
                <div className={'row modal-actions'}>
                    <TransparentButton onClick={onCancel}>
                        Cancel
                    </TransparentButton>
                    <BlueContainedButton
                        text={'Save brands'}
                        onClick={this.save}
                    />
                </div>
            </div>
        );
    }
}
